import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ConfigManager = /*#__PURE__*/function () {
  function ConfigManager() {
    _classCallCheck(this, ConfigManager);

    this._appConfig = null;
  }

  _createClass(ConfigManager, [{
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: "appConfig",
    get: function get() {
      return this._appConfig;
    },
    set: function set(value) {
      this._appConfig = value;
    }
  }]);

  return ConfigManager;
}(); // Singleton Export


var configManager = new ConfigManager();
var _default = configManager;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ConfigManager, "ConfigManager", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/managers/ConfigManager.js");
  reactHotLoader.register(configManager, "configManager", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/managers/ConfigManager.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/managers/ConfigManager.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();